import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import MyVouchersStatement from "./VoucherDetails/VoucherDetails";
import { connect } from "react-redux";

const MyVouchersPage = ({id, isGhosting}) => {
  return (
    <Container fluid>
      <Row>
        <Col>
          <MyVouchersStatement employeeId={id} isGhosting={isGhosting} />
        </Col>
      </Row>
    </Container>
  );
}

function mapStateToProps(state) {
  const profile = state.profile;
  return profile.ghost ? 
    { id: profile.ghost, isGhosting: true } : 
    { id: profile.employeeId, isGhosting: false };
}

export default connect(mapStateToProps)(MyVouchersPage);
